// Converts decimal size to fractional display (e.g., 0.5 -> "1/2", 1.5 -> "1 1/2")
export function formatSizeAsFraction(decimal) {
  if (!decimal || isNaN(decimal)) {
    return '';
  }
  
  const num = parseFloat(decimal);
  const whole = Math.floor(num);
  const fraction = num - whole;
  
  // Common fractions used in sizing
  const fractions = [
    [0, ''],
    [0.125, '1/8'],
    [0.25, '1/4'],
    [0.375, '3/8'],
    [0.5, '1/2'],
    [0.625, '5/8'],
    [0.75, '3/4'],
    [0.875, '7/8']
  ];
  
  // Find the closest fraction (with small tolerance for floating point)
  let fractionText = '';
  for (let i = 0; i < fractions.length; i++) {
    if (Math.abs(fraction - fractions[i][0]) < 0.001) {
      fractionText = fractions[i][1];
      break;
    }
  }
  
  // Build the display string
  if (whole === 0) {
    return fractionText || num.toString();
  } else if (fractionText === '') {
    return whole.toString();
  } else {
    return whole + ' ' + fractionText;
  }
}

// Make it globally available for legacy code
window.formatSizeAsFraction = formatSizeAsFraction;
